import { useState, useEffect } from 'react'

const CASCADE_FRAMES = [
  '⠀⠀⠀⠀', '⠀⠀⠀⠀', '⠁⠀⠀⠀', '⠋⠀⠀⠀',
  '⠞⠁⠀⠀', '⡴⠋⠀⠀', '⣠⠞⠁⠀', '⢀⡴⠋⠀',
  '⠀⣠⠞⠁', '⠀⢀⡴⠋', '⠀⠀⣠⠞', '⠀⠀⢀⡴',
  '⠀⠀⠀⣠', '⠀⠀⠀⢀',
]
const CASCADE_INTERVAL = 60

export default function CascadeSpinner({ className = '' }: { className?: string }) {
  const [frame, setFrame] = useState(0)

  useEffect(() => {
    const id = setInterval(() => {
      setFrame(f => (f + 1) % CASCADE_FRAMES.length)
    }, CASCADE_INTERVAL)
    return () => clearInterval(id)
  }, [])

  return (
    <span className={`inline-block font-mono text-sm leading-none ${className}`}>
      {CASCADE_FRAMES[frame]}
    </span>
  )
}
